//#region src/link.ts
var preloadWarning = "Error preloading route! ☝️";
//#endregion
export { preloadWarning };

//# sourceMappingURL=link.js.map